module.exports = __webpack_public_path__ + "img/1538223585.364264e9.jpg";